import { t } from "../store-language/i18n.ts";
import "./RajBrandFooter.css";

/** Public attribution always opens the main Raj domain. */
export default function RajBrandFooter() {
  return (
    <footer className="raj-brand-footer">
      <a
        href="https://rajsystem.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("طراحی و توسعه توسط رَج")}
      >
        <span>{t("طراحی و توسعه توسط")}</span>
        <strong>{t("رَج")}</strong>
      </a>
    </footer>
  );
}
